/* Complete the Fit (snippets/bd-complete-fit.liquid).
   Adding to cart is Dawn's <product-form> (product-form.js): this file never
   posts anything. It:
   - <bd-complete-fit> loader: fetches Shopify's native Complementary
     products for this product (Product Recommendations API,
     intent=complementary, rendered by this same section) and swaps the
     module in. Nothing returned = the element stays empty (no heading, no
     space). Separate from Dawn's related-products loader;
   - opens/closes an add-on's inline size chooser (nothing pre-selected);
   - copies the picked size into the form's hidden name="id" input and only
     then enables Add (sold-out sizes are disabled radios in the markup);
   - after Dawn reports a successful add of that exact variant
     (PUB_SUB_EVENTS.cartUpdate), collapses and resets the chooser and hands
     the cart's "return focus" target to the visible Choose size button. */
(function () {
  if (window.bdCompleteFitReady) return;
  window.bdCompleteFitReady = true;

  if (!customElements.get('bd-complete-fit')) {
    customElements.define(
      'bd-complete-fit',
      class BdCompleteFit extends HTMLElement {
        connectedCallback() {
          var url = this.dataset.url;
          if (!url || this.dataset.loading) return;
          this.dataset.loading = 'true';
          var self = this;
          fetch(url + '&product_id=' + encodeURIComponent(this.dataset.productId) + '&section_id=' + encodeURIComponent(this.dataset.sectionId))
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .then(function (text) {
              if (!text) return;
              var fresh = new DOMParser().parseFromString(text, 'text/html').getElementById(self.id);
              if (fresh && fresh.querySelector('[data-bd-ctf-item]')) self.innerHTML = fresh.innerHTML;
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      }
    );
  }

  function parts(item) {
    return {
      toggle: item.querySelector('[data-bd-ctf-toggle]'),
      chooser: item.querySelector('[data-bd-ctf-chooser]'),
      input: item.querySelector('[data-bd-ctf-variant]'),
      submit: item.querySelector('.bd-ctf__submit'),
    };
  }

  function setOpen(item, open) {
    var p = parts(item);
    if (!p.toggle || !p.chooser) return;
    p.chooser.hidden = !open;
    p.toggle.setAttribute('aria-expanded', String(open));
    item.classList.toggle('is-open', open);
    if (!open) {
      p.chooser.querySelectorAll('.bd-ctf__radio').forEach(function (radio) {
        radio.checked = false;
      });
      if (p.input) p.input.value = '';
      if (p.submit) p.submit.disabled = true;
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-bd-ctf-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-bd-ctf-item]');
    if (item) setOpen(item, toggle.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('change', function (event) {
    var radio = event.target.closest('.bd-ctf__radio');
    if (!radio || radio.disabled) return;
    var item = radio.closest('[data-bd-ctf-item]');
    var p = parts(item);
    if (p.input) p.input.value = radio.value;
    if (p.submit) p.submit.disabled = false;
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var chooser = event.target.closest && event.target.closest('[data-bd-ctf-chooser]');
    if (!chooser) return;
    var item = chooser.closest('[data-bd-ctf-item]');
    setOpen(item, false);
    var toggle = parts(item).toggle;
    if (toggle) toggle.focus();
  });

  function onAdded(event) {
    if (!event || event.source !== 'product-form' || !event.productVariantId) return;
    document.querySelectorAll('[data-bd-ctf-item].is-open').forEach(function (item) {
      var p = parts(item);
      if (!p.input || p.input.value !== String(event.productVariantId)) return;
      setOpen(item, false);
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.setActiveElement === 'function' && p.toggle) cart.setActiveElement(p.toggle);
    });
  }

  function listen() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onAdded);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
  else listen();
})();
